<hpf-language-form
        *ngIf="language"
        [language]="language"
        (create)="onCreate($event)"
    ></hpf-language-form>
<div *ngIf="!language" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>